import { render, staticRenderFns } from "./DistintaDiPrelievo.vue?vue&type=template&id=51368ab2&scoped=true&"
import script from "./DistintaDiPrelievo.vue?vue&type=script&lang=js&"
export * from "./DistintaDiPrelievo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51368ab2",
  null
  
)

export default component.exports